import { Dispatch, SetStateAction } from 'react'

import { usePaymentOrderInfo } from 'features/Orders/Review/components/PayView/components/Invoice/invoice.queries'
import { convertGlobalIdToRetailerAccount } from 'features/Orders/Review/components/PayView/utils'
import SendPaymentRequestModal from 'features/Orders/Review/modals/SendPaymentRequestModal/SendPaymentRequestModal'
import { formatOrderAddress } from 'features/Orders/Review/utils/addresses.utils'

interface Props {
  isModalOpen: boolean
  setIsModalOpen: Dispatch<SetStateAction<boolean>>
}

const ApprovedOrderRequestPaymentModal = ({
  isModalOpen,
  setIsModalOpen,
}: Props) => {
  const { order } = usePaymentOrderInfo()

  return (
    <SendPaymentRequestModal
      isOpen={isModalOpen}
      setIsOpen={setIsModalOpen}
      orderId={order?.id}
      orderPO={order?.referenceNumber}
      orderCurrency={order?.priceType?.currency?.code}
      retailerId={convertGlobalIdToRetailerAccount(order?.retailerProfile?.id)}
      retailerName={order?.retailerProfile?.displayName}
      retailerEmail={
        order?.shipping?.address?.email || order?.retailerProfile?.email
      }
      webOrderId={order?.webOrderLookupId}
      brandId={order?.brand?.id}
      brandName={order?.brand?.name}
      billingAddress={formatOrderAddress(order?.billing?.address)}
      hasRefetchPaymentInfo
    />
  )
}

export default ApprovedOrderRequestPaymentModal
